module.exports = __webpack_public_path__ + "static/img/title1.4f9383e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/yxds2021/title1.png
// module id = RT+p
// module chunks = 0